import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { setVadMakeModelOptions } from '../store/options.actions'

export function* getVadMakeModelOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getVadMakeModelOptions])
    const { entity } = response
    yield put(setVadMakeModelOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getVadMakeModelOptions() error: ${e}`))
  }
}
export function* getVadMakeModelOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getVadMakeModelOptions)
}
